import React, {useContext, useState, useEffect, useRef} from 'react';
import { useParams } from 'react-router-dom';
//componentns
import ScrollToTop from '../components/ScrollToTop';
// import ReserveForm from '../components/ReserveForm';
import Testimonial from '../components/Testimonial';
import AboutUs from '../components/AboutUs';
//context
import { RoomContext } from '../context/RoomContext';
//icons
import { FaCheck } from 'react-icons/fa';
import { FaPhone, FaEnvelope, FaUser } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';
import { SpinnerDotted } from 'spinners-react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';



const RoomDetails = () => {

  const [t, i18n] = useTranslation("global");

  const [loading, setLoading] = useState(true);
  const [showPhoneLink, setShowPhoneLink] = useState(false);
  const [showEmailLink, setShowEmailLink] = useState(false);

  const [isFullScreen, setIsFullScreen] = useState(false);
  const [fullScreenImage, setFullScreenImage] = useState(null);
  const [fullScreenImageIndex, setFullScreenImageIndex] = useState(null);

  const handleImageClick1 = (index) => {
    setFullScreenImageIndex(index);
    setIsFullScreen(true);
  };

  const handleCloseFullScreen = () => {
    setIsFullScreen(false);
    setFullScreenImageIndex(null);
  };

  const handlePrevImage = () => {
    setFullScreenImageIndex((prevIndex) => (prevIndex - 1 + imageLg.length) % imageLg.length);
  };

  const handleNextImage = () => {
    setFullScreenImageIndex((prevIndex) => (prevIndex + 1) % imageLg.length);
  };

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setShowPhoneLink(true);
      setShowEmailLink(true);
    }, 6000);
  }, []);

  const {rooms} = useContext(RoomContext);
  const {id} = useParams();

  //get room
  const room = rooms.find((room) => {
    return room.id === Number(id);
  })
  //destructure room
  const {name, description, facilities, imageLg, phoneNumber, adresa, linkMape, imageLGBanner} = room;

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isTransitioning, setTransitioning] = useState(false);

  //odavde novo lazy
  const [nextImageIndex, setNextImageIndex] = useState(1);
  const observer = useRef(null);
  useEffect(() => {
    if (observer.current) {
      observer.current.disconnect();
    }
    observer.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = parseInt(entry.target.getAttribute('data-index'), 10);
            setNextImageIndex(index + 1);
          }
        });
      },
      { rootMargin: '200px' }
    );
    const images = document.querySelectorAll('.lazy-load');
    images.forEach((img) => observer.current.observe(img));

    return () => observer.current.disconnect();
  }, [currentImageIndex]);

   // Function to handle image click
   const handleImageClick = (index) => {
    // setCurrentImageIndex(index);
    setTransitioning(true);
    setTimeout(() => {
      setCurrentImageIndex(index);
      setTransitioning(false);
    }, 300);
  };

  // Variables to store touch start coordinates
  let startX = 0;
  let startY = 0;

  // Function to handle touch start
  const handleTouchStart = (e) => {
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
  };

  // Function to handle touch end
  const handleTouchEnd = (e) => {
    const deltaX = e.changedTouches[0].clientX - startX;
    const deltaY = e.changedTouches[0].clientY - startY;

    // Check if the swipe is horizontal and long enough
    if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 50) {
      // Swipe left
      if (deltaX > 0) {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % imageLg.length);
      }
      // Swipe right
      else {
        setCurrentImageIndex((prevIndex) =>
          prevIndex === 0 ? imageLg.length - 1 : prevIndex - 1
        );
      }
    }
  };

  const handleArrowClick = (direction) => {
    let newIndex;
  
    if (direction === 'left') {
      newIndex =
        currentImageIndex === 0
          ? imageLg.length - 1
          : currentImageIndex - 1;
    } else if (direction === 'right') {
      newIndex =
        currentImageIndex === imageLg.length - 1
          ? 0
          : currentImageIndex + 1;
    }
  
    setCurrentImageIndex(newIndex);
  };
  
  const location = useLocation();
  const apartmentId = location.pathname.split('/').pop();
  const apartmentDescription8 = apartmentId === '1' ? t(`dreamPageText.description8`) : apartmentId === '2' ? t(`dcPageText.description8`) : '';
  const apartmentDescription9 = apartmentId === '1' ? t(`dreamPageText.description9`) : apartmentId === '2' ? t(`dcPageText.description9`) : '';
  const apartmentDescription10 = apartmentId === '1' ? t(`dreamPageText.description10`) : apartmentId === '2' ? t(`dcPageText.description10`) : '';

  return (
  <section>
      <Helmet>
        <title>{name} | Apartmani Novi Sad</title>
      </Helmet>
    {loading && (
        <div className='h-screen fixed bottom-0 top-0 bg-black/90 w-full z-50 flex justify-center items-center'>
          <SpinnerDotted color='white' />
        </div>
      )}
    <ScrollToTop />
    {/* {banner} flex-col */}
    <div className='bg-room bg-cover bg-center h-[560px] relative flex justify-center items-center'
    style={{backgroundImage:`url(${imageLGBanner})`}}>
      {/* overlay */}
      <div className='absolute w-full h-full bg-black/70'></div>
        {/* title */}
        <h1 className='leading-tight text-[32px] lg:text-[68px] tracking-[2px] text-white z-20 font-primary text-center'>{name}</h1>
    </div>
    <div className='container mx-auto'>
      <div className='flex flex-col lg:flex-row h-full py-24'>
        {/* left */}
        <div className='w-full h-full lg:w-[60%] px-6'>
          <h2 className='h2 mb-8'>{name}</h2>
          {/* <p className='mb-3'>{apartmentDescription1}</p>
          <p className='mb-3'>{apartmentDescription2}</p>
          <p className='mb-8'>{apartmentDescription4}</p> */}

          <div
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
            style={{ position: 'relative', overflow: 'hidden' }}
          >
          {/* Display current image */}
            <div
              className={`transition-transform ${
                isTransitioning ? 'transform' : ''
              }`}
              style={{
                display: 'flex',
                transform: `translateX(-${currentImageIndex * 100}%)`,
              }}
            >
              {imageLg.map((src, index) => (
                  <img key={index} className="w-full mb-8 lazy-load" src={currentImageIndex === index || nextImageIndex === index ? src : ''} alt={`Room ${index + 1}`} style={{ flex: '0 0 100%', opacity: currentImageIndex === index ? 1 : 0, transition: 'opacity 0.3s ease' }} 
                  data-index={index} 
                  onClick={() => handleImageClick1(index)} />
                ))}
            {/* {imageLg.map((src, index) => (
              <img
                key={index}
                className="w-full mb-8"
                src={src}
                alt={`Room ${index + 1}`}
                style={{
                  flex: '0 0 100%',
                  opacity: currentImageIndex === index ? 1 : 0,
                  transition: 'opacity 0.3s ease', // Add opacity transition
                }}
              />
            ))} */}
          </div>
          {isFullScreen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center"
          style={{ zIndex: 1000 }}
        >
          <div className="relative">
            <button
              onClick={handleCloseFullScreen}
              className="absolute top-0 right-0 mt-4 mr-4 text-white text-2xl"
            >
              &times;
            </button>
            <button
              onClick={handlePrevImage}
              className="absolute left-0 top-1/2 transform -translate-y-1/2 ml-4 text-white text-2xl"
            >
              &#10094;
            </button>
            <img src={imageLg[fullScreenImageIndex]} className="max-w-full max-h-full" alt="Full Screen" />
            <button
              onClick={handleNextImage}
              className="absolute right-0 top-1/2 transform -translate-y-1/2 mr-4 text-white text-2xl"
            >
              &#10095;
            </button>
          </div>
        </div>
      )}
          {/* {isFullScreen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center"
          style={{ zIndex: 1000 }}
        >
          <div className="relative">
            <button
              onClick={handleCloseFullScreen}
              className="absolute top-0 right-0 mt-4 mr-4 text-white text-2xl"
            >
              &times;
            </button>
            <img src={fullScreenImage} className="max-w-full max-h-full" alt="Full Screen" />
          </div>
        </div>
      )} */}

          <div className='flex justify-center mt-4'>
              {/* Left Arrow */}
              <div
                      onClick={() => handleArrowClick('left')}
                      className='transform -translate-y-2/5 cursor-pointer text-2xl text-black'
                    >
                &lt;
              </div>

              {/* Display circles for image navigation */}
          <div className='flex flex-wrap w-[75%] md:w-auto mx-auto items-center ml-4 mr-4'>
          {imageLg.map((_, index) => (
          <div
            key={index}
            onClick={() => handleImageClick(index)}
            className={`w-[10px] h-[10px] rounded-[50%] m-1 md:m-2 ${
              currentImageIndex === index ? 'bg-accent' : 'bg-transparent'
            } border border-black cursor-pointer`}
          ></div>
          ))}
          </div>

           {/* Right Arrow */}
           <div
                    onClick={() => handleArrowClick('right')}
                    className='transform -translate-y-2/5 cursor-pointer text-2xl text-black'
                  >
                    &gt;
                  </div>
              
          </div>
        </div>

          {/* facilities */}
          <div className='mt-12'>
          <hr className="mt-20 pt-16 w-3/4 mx-auto border-black" />
            <h3 className='h3 mb-6'>{t(`dreamPageText.naslovSadrzaja`)}</h3>
            <p className='mb-2'>
            {apartmentDescription8}
            </p>
            <p className='mb-2'>
            {apartmentDescription9}
            </p>
            <p className='mb-12'>
            {apartmentDescription10}
            </p>
            {/* <p className='mb-12'>
            {apartmentDescription3}
            </p> */}
            {/* grid grid-cols-3  */}
            <div className='grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 gap-6'>
              {facilities.map((item, index) => {
                // destructure item
                const {name, icon} = item;
                return (
                <div className='flex items-center gap-x-3 flex-1' key={index}>
                  <div style={{ fontSize: '2em', lineHeight: 1 }} className='text-accent'>{icon}</div>
                  <div className='text-base'>{name}</div>
                </div>
                );
              })}
            </div>
            
            
            {/* <Testimonial currentPage={apartmentId} /> */}
          </div>
        </div>
        {/* {rigt} */}
        <div className='w-full h-full lg:w-[40%]'>
              {/* reservation */}
              {/* <ReserveForm apartmentName={name} /> */}
              {/* rules */}
              
              <Testimonial currentPage={apartmentId} />
              {/* Location */}
              <div id='locationRoom' className='pt-16 mb-12 mt-0'>
              {/* <hr className="pt-20 w-3/4 mx-auto border-black" /> */}
                <h3 className='h3'>{name} - {t(`navBarT.locations`)}</h3>
                <p>{adresa}, Novi Sad, Serbia</p>

                {/* Google Map Embed */}
                {/* https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2809.3183257083447!2d19.807997376092096!3d45.24135537107126!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x475b102c2999fb27%3A0x9ba112aea55209f5!2sAdi%20Endrea%2030%2C%20Novi%20Sad%20406331%2C%20Serbia!5e0!3m2!1sen!2smk!4v1704808017346!5m2!1sen!2smk */}
                <div className='mt-4'>
                <iframe src={linkMape}
                width="100%" 
                height="300" 
                style={{ border: 0 }} 
                allowFullScreen="" 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade">
                </iframe>
                </div>
              </div>
              
              <div>
              {/* <hr className="mt-12 pt-12 w-3/4 mx-auto border-black" /> */}
                <h3 className='h3'>{t(`pravila.naslov`)}</h3>
                <p className='mb-6'>
                </p>
                <ul className='flex flex-col gap-y-4'>
                  <li className='flex items-center gap-x-4'>
                    <FaCheck className='text-accent' />
                    {/* Check-In: 12:00 PM - 10:00 PM */}
                    {t(`pravila.pravilo1`)}
                  </li>
                  <li className='flex items-center gap-x-4'>
                    <FaCheck className='text-accent' />
                    {t(`pravila.pravilo2`)}
                  </li>
                  <li className='flex items-center gap-x-4'>
                    <FaCheck className='text-accent' />
                    {t(`pravila.pravilo3`)}
                  </li>
                  <li className='flex items-center gap-x-4'>
                    <FaCheck className='text-accent' />
                    {t(`pravila.pravilo4`)}
                  </li>
                  <li className='flex items-center gap-x-4'>
                    <FaCheck className='text-accent' />
                    {t(`pravila.pravilo5`)}
                  </li>
                  {/* <li className='flex items-center gap-x-4'>
                    <FaCheck className='text-accent' />
                    No Parties
                  </li> */}
                </ul>
              </div>
              
              {/* <a href={`tel:${phoneNumber}`} className='btn btn-lg btn-primary w-[80%] mt-0 lg:mt-20 mb-4 mx-auto shadow-lg'>
                <FaPhone className='mr-2' />
                Contact Us: {phoneNumber}
              </a> */}
        </div>
      </div>
    {/* Contact links */}
{showPhoneLink && (
  <div className='fixed bottom-4 left-4 flex items-center justify-center transition-all duration-500'>
    <a href={`tel:${phoneNumber}`} className='contact-link phone w-12 md:w-16 h-12 md:h-16 btn-primary rounded-full flex items-center justify-center shadow-lg'>
      <FaPhone className='icon text-white w-8 md:w-10 h-8 md:h-10' />
    </a>
  </div>
)}
{showEmailLink && (
  <div className='fixed bottom-4 right-4 flex items-center justify-center transition-all duration-500'>
    <a href={`mailto:ivan.popadic@gmail.com`} className='contact-link email w-12 md:w-16 h-12 md:h-16 btn-primary rounded-full flex items-center justify-center shadow-lg'>
      <FaEnvelope className='icon text-white w-8 md:w-10 h-8 md:h-10' />
    </a>
  </div>
)}




      <hr className=" mt-0 mb-8 w-[90%] mx-auto border-black" />
      <AboutUs apartmentId={apartmentId}/>
    </div>
  </section>
  );
};

export default RoomDetails;
